export const GUTTER = 2;

export const CONTROL_HEIGHTS = {
  xsmall: 26,
  small: 32,
} as const;

export const initialRect = {
  left: 0,
  top: 0,
  height: 0,
  width: 0,
};
